import React from 'react'
import { withRouteData, Head } from 'react-static'
import {
  DateBox,
  Flex,
  Box,
  A,
  Text,
  Image,
  HeadingWithAnchor as Heading,
  Container,
} from 'components'

export default withRouteData(({
  project
}) => (
  <Container py={[5, , 6]} maxWidth="large">
    <Head>
      <title>Will Hoag - Project - {project.title}</title>
      <meta name="description" content={`A case study for ${project.title} - ${project.blurb}`} />
    </Head>
    <Flex flexWrap="wrap" alignItems="center">
      {project.image && 
        <Box mb={[4, 0]} w={[1, 1/2, 1/3]}>
          <Image src={project.image} alt={`depiction of project called ${project.title}`} borderRadius={2} />
        </Box>}
      <Box w={project.image ? [1, 1/2, 2/3] : 1} pl={project.image ? [0, 4, , 5] : 0}>
        <Flex flexWrap="wrap" justifyContent="space-between" alignItems="top">
          <Heading is="h1" mt={0} mb={2} mr={4}>{project.title}</Heading>
          {project.launchdate &&
            <Box>
              <DateBox preText="Launched" dateFormat={'yyyy'} date={project.launchdate} my={2}/>
            </Box>}
        </Flex>
        {project.blurb &&
          <Heading is="h2" fontSize={3}>{project.blurb}</Heading>}
        {project.description &&
          <Text is="p" fontSize={3}>{project.description}</Text>}
        {project.url &&
          <A href={project.url} target="_blank">Visit Site</A>}
      </Box>
    </Flex>
  </Container>
))



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Project.js